export default {
    copyFiscalAddress: true
};
